import { Box, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { VotingPreview, convertHtmlToText } from "@lubbezposrednio-frontend/core";

const TYPE_LABELS: Record<string, string> = { yes_no: "TAK / NIE", single: "Jeden wybór", multiple: "Wiele wyborów" };

export const VotingPreviewBox: React.FC<{ preview: VotingPreview }> = ({ preview }) => (
  <Box w="100%" bg="white" boxShadow="0 8px 24px rgba(67,0,152,0.06)" borderRadius="22px" p={{ base: "22px", md: "26px" }}>
    <Text fontSize="13px" fontWeight="700" color="primary" mb="16px">
      W tym głosowaniu zdecydujesz o:
    </Text>

    <VStack align="stretch" spacing="12px">
      {preview.questions.map((q, i) => (
        <Box key={i} bg="#FAF8FE" border="1px solid rgba(67,0,152,0.06)" borderRadius="16px" p={{ base: "14px", md: "16px 18px" }}>
          <HStack align="flex-start" spacing="13px">
            <Flex w="28px" h="28px" borderRadius="full" bg="primary" color="white" fontSize="13px" fontWeight="800" align="center" justify="center" flexShrink={0}>
              {i + 1}
            </Flex>
            <Box flex="1" minW={0}>
              <Text fontWeight="700" color="primary" fontSize={{ base: "15px", md: "16px" }} lineHeight="1.35">
                {convertHtmlToText(q.content)}
              </Text>
              <HStack mt="9px" spacing="6px" wrap="wrap">
                <HStack spacing="5px" bg="rgba(67,0,152,0.08)" color="primary" px="9px" py="3px" borderRadius="full">
                  <Text fontSize="11px" fontWeight="700" letterSpacing="0.02em">
                    {TYPE_LABELS[q.qtype] ?? q.qtype}
                  </Text>
                </HStack>
                {q.answers.map((a, j) => (
                  <Text key={j} fontSize="12.5px" fontWeight="600" color="gray.600" bg="white" border="1px solid rgba(67,0,152,0.1)" px="10px" py="3px" borderRadius="full">
                    {a}
                  </Text>
                ))}
              </HStack>
            </Box>
          </HStack>
        </Box>
      ))}
    </VStack>
  </Box>
);
